// SPDX-License-Identifier: LicenseRef-Proprietary

import React from 'react';
import VaccineDashboardView from './VaccineDashboardView';

/**
 * Container component - now just renders the view
 * All state management is handled by Zustand store via connected components
 * The store is initialized automatically when first accessed
 */
const VaccineDashboardContainer: React.FC = () => {
  return <VaccineDashboardView />;
};

export default VaccineDashboardContainer;

